import React from "react";
import PageHeader from "../../components/common/PageHeader";
import useAuth from "../../hooks/useAuth";

const Home = () => {
  const { isTenantUser, contextLabel } = useAuth();

  return (
    <PageHeader
      title="Dashboard"
      subtitle={
        isTenantUser
          ? `${contextLabel} tenant overview`
          : "System administration overview"
      }
    />
  );
};

export default Home;
